<template>
    <HeaderVue>
        <template #header>
            <div class="row align-center header-account">
                <div class="avatar">
                    <img src="@/assets/images/logo.png" alt="" />
                </div>
                <div class="name">{{ this.TenTaiKhoan }}</div>
            </div>
        </template>
    </HeaderVue>

    <div class="danh-sach-chuc_nang" style="margin-top: 100px">
        <div
            v-for="(item, index) in DanhSachChucNang"
            :key="index"
            class="item-chuc-nang pl-3 py-1"
        >
            <div
                class="row align-center justify-space-between"
                @click="ChonChucNang(item.to)"
            >
                <div class="font-16 font-medium">
                    {{ item.text }}
                </div>
                <div>
                    <DxButton
                        type="default"
                        stylingMode="text"
                        :icon="`mdi ${item.iconCommon}`"
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-3 px-3">
        <!-- style="
            position: fixed;
            bottom: 38px;
            left: 0;
            background-color: #fff;
            border-top: 1px solid #ccc;
            padding: 8px 16px;
            width: 100%;
        " -->
        <div class="xs12">
            <DxButton
                text="ĐĂNG XUẤT"
                type="danger"
                styling-mode="outlined"
                width="100%"
                @click="$Core.Auth.Logout()"
            />
        </div>
    </div>
</template>

<script>
import { DxButton } from "devextreme-vue";
import HeaderVue from "@/components/Header/Header.vue";

export default {
    components: {
        DxButton,
        HeaderVue,
    },
    data() {
        return {
            TenTaiKhoan: null,
            DanhSachChucNang: [
                {
                    id: 1,
                    to: "/",
                    disable: false,
                    text: "Trang chủ",
                    iconCommon: "mdi mdi-chevron-right",
                    role: null,
                },
            ],
        };
    },
    methods: {
        ChonChucNang(to) {
            this.$router.push(to);
        },
    },
    created() {
        this.TenTaiKhoan =
            this.$Core.Auth.TokenParsed != null
                ? this.$Core.Auth.TokenParsed.given_name ||
                  this.$Core.Auth.TokenParsed.name ||
                  this.$Core.Auth.TokenParsed.preferred_username ||
                  "<Chưa cài đặt>"
                : "<Chưa cài đặt>";
    },
};
</script>

<style scoped>
.header-account {
    height: 96px;
    background: #03a9f4;
    padding: 16px 16px 16px 8px;
}
.avatar {
    width: 56px;
    height: 56px;
    background: #fff;
    border-radius: 50%;
    padding: 4px;
}
.avatar img {
    width: 100%;
    height: 100%;
}
.name {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}

.item-chuc-nang {
    border-bottom: 1px solid #ccc;
}
</style>
